import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { DataPackService } from '../../../../../app/models/DataPackService.model'
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { DataPackLineAcount } from '../../../../models/dataPackLineAcount.model';
import { DataPackGroup } from '../../../../models/dataPackGroup.model';

  import * as _ from "lodash";

/**
 * @version $Id: content.component.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
*/
@Component({
  selector: 'voiceBlockComponent',
  templateUrl: './content.template.html'
})
export class VoiceBlockComponent implements OnInit {

  private isConfigsBloqueio: boolean = false;
  private isConfigsGroupBloqueio: boolean = false;
  private lineNew: DataPackLine = new DataPackLine();
  private groupNew: DataPackGroup = new DataPackGroup();
  private lineAcountList: any = [];
  private listOpcoesBlockLines: Map<number, DataPackService> = new Map<number, DataPackService>();

  constructor(private bindComponent: BindComponentService) {

  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'BLOCK_VOICE_FILTER'); //ALTERADO
    this.bindComponent.subscribe(BindComponentService.OPEN_SCREEN_BLOC_VOICE,
      condicao => {
        this.isConfigsBloqueio = condicao;
      });
    this.bindComponent.subscribe(BindComponentService.BLOCK_VOICE_DATA_PACK_LINE,
      lineAcount => {
        this.lineNew = lineAcount;
      });
    this.bindComponent.subscribe(BindComponentService.LIST_ACOUNT_BLOC_VOICE,
      selectedLine => {
        this.lineAcountList = selectedLine;
      });
    this.bindComponent.subscribe(BindComponentService.LIST_CONFIG_BLOC_VOICE,
      configMultipleBlockVoice => {
        this.listOpcoesBlockLines = configMultipleBlockVoice;
      });
    this.bindComponent.subscribe(BindComponentService.OPEN_SCREEN_BLOC_GROUP_VOICE,
      condicao => {
        this.isConfigsGroupBloqueio = condicao;
      });
    this.bindComponent.subscribe(BindComponentService.BLOCK_VOICE_DATA_PACK_GROUP,
      group => {
        this.groupNew = group;
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/voice/content.component.ts